export class ApiSource {
    public id: number | null;
    public name: string;

    constructor(data: ApiSourceData | void) {
        if (data === undefined) {
            this.id = null;
            this.name = "";

        } else {
            this.id = data.id;
            this.name = data.name;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.name = "";
    }

    public serializeData():ApiSourceData {
        return {
            id: this.id,
            name: this.name,
        }
    }
}

export type ApiSourceData = {
    id: number | null;
    name: string;
}